import clsx from 'clsx'
import {Link, useLocation} from 'react-router-dom'
import {useLayout} from "../../../core"
import {usePageData} from "../../../core"

import {UiIcon} from '../../../../../components/UiIcon'
import './DefaultTitle.scss'

const sectionHeaders: Record<string, {label: string; icon: string}> = {
  dashboard: {label: 'SINIF PANELİ', icon: 'people'},
  student: {label: 'ÖĞRENCİ YÖNETİMİ', icon: 'people'},
  classroom: {label: 'SINIF YÖNETİMİ', icon: 'people'},
  homework: {label: 'OKUMA SORUMLULUKLARI', icon: 'history'},
  curriculum: {label: 'KİTAPLIK YÖNETİMİ', icon: 'book'},
  activities: {label: 'ETKİNLİK KÜTÜPHANESİ', icon: 'activity'},
  profile: {label: 'HESABIM', icon: 'people'},
}

const DefaultTitle = () => {
  const {pathname} = useLocation()
  const section = sectionHeaders[pathname.split('/')[1]] || {label: 'ÖĞRETMEN PANELİ', icon: 'grid'}
  const icon = /\/(create|add)\/?$/.test(pathname) ? 'plus' : section.icon
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config} = useLayout()
  return (
    <div
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', lg: '#kt_header_container'}"
      className='page-title education-page-title d-flex flex-column align-items-start justify-content-center flex-wrap me-lg-2 pb-5 pb-lg-0'
    >
      {/* begin::Heading */}
      {pageTitle && (
        <>
          <span className='education-title-eyebrow'>{section.label}</span>
          <div className='education-title-main'>
            <span className='education-title-icon'><UiIcon name={icon} size={26}/></span>
            <div>
              <h1 className='d-flex flex-column text-dark fw-bolder my-0 fs-1'>
                {pageTitle}
              </h1>
              {pageDescription && (
                <p className='page-title-description'>{pageDescription}</p>
              )}
            </div>
          </div>
        </>
      )}
      {/* end::Heading */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.pageTitle &&
        config.pageTitle.breadCrumbs && (
          <ul className='breadcrumb breadcrumb-dot fw-bold fs-base my-1'>
            {Array.from(pageBreadcrumbs)
              .filter((b) => !b.isSeparator)
              .map((item, index) => (
                <li
                  className={clsx('breadcrumb-item', {
                    'text-dark': !item.isSeparator && item.isActive,
                    'text-muted': !item.isSeparator && !item.isActive,
                  })}
                  key={`${item.path}${index}`}
                >
                  <Link className='text-muted' to={item.path}>
                    {item.title}
                  </Link>
                </li>
              ))}
            <li className='breadcrumb-item text-dark'>{pageTitle}</li>
          </ul>
        )}
    </div>
  )
}

export {DefaultTitle}
